import { combineReducers } from 'redux'
import { 
    KAPAL_GET_SUCCESS, KAPAL_GET_MODAL, KAPAL_EDIT,
    LIST_OP_GET_SUCCESS, ADD_MASTER_GET_SUCCESS,
    KAPAL_GET_DELL_MODAL, DELL_MASTER_GET_SUCCESS,
    MASTER_KAPAL_OPERATOR
} from '../actions/constant'


const tableLoad = (state = false, action) => {
    switch (action.type) {
      case KAPAL_GET_SUCCESS:
        return action.load
      default:
        return state
    }
  }
  
const kapal = (state = [], action) => {
  switch (action.type) {
    case KAPAL_GET_SUCCESS:
      return action.val
    default:
      return state
  }
}

const listkapalop = (state = [], action) => {
  switch (action.type) {
    case MASTER_KAPAL_OPERATOR:
      return action.val
    default:
      return state
  }
}

const listoperator = (state = [], action) => {
  switch (action.type) {
    case LIST_OP_GET_SUCCESS:
      return action.listoperator.data
    default:
      return state
  }
}

const modal = (state = false, action) => {
  switch (action.type) {
    case KAPAL_GET_MODAL:
      return action.val
    default:
      return state
  }
}

const dellmodal = (state = {bool: false, val: null}, action) => {
  switch (action.type) {
    case KAPAL_GET_DELL_MODAL:
      return action.val
    default:
      return state
  }
}

const dellmaster = (state = {message:null, loading:false}, action) => {
  switch (action.type) {
    case DELL_MASTER_GET_SUCCESS:
      return  { message:action.dellData, loading:action.load }
    default:
      return state
  }
}

const editData = (state = false, action) => {
  switch (action.type) {
    case KAPAL_EDIT:
      return action.val
    default:
      return state
  }
}

const addMaster = (state = {message:null, loading:false}, action) => {
  switch (action.type) {
    case ADD_MASTER_GET_SUCCESS:
      return { message:action.addData, loading:action.load }
    default:
      return state
  }
}
  
const kapalReducer = combineReducers({
    kapal,
    listkapalop,
    listoperator,
    tableLoad,
    modal,
    dellmodal,
    editData,
    dellmaster,
    addMaster
  })
  
  export default kapalReducer
  